import Error403 from "@/views/errors/403";
import Error404 from "@/views/errors/404";
import Error500 from "@/views/errors/500";

const routes = [
  {
    path: "/403",
    name: "Error403",
    component: Error403,
    meta: {
      title: "message403",
      anonymousAccess: true
    }
  },
  {
    path: "/500",
    name: "Error500",
    component: Error500,
    meta: {
      title: "message500",
      anonymousAccess: true
    }
  },
  {
    path: "*",
    name: "Error404",
    component: Error404,
    meta: {
      title: "message404",
      anonymousAccess: true
    }
  }
];

export default routes;
